import React from "react";
import Link from "../Link";
import right2 from "../../img/right@2x.svg";
import group5 from "../../img/group-6-black.svg";
import "./RegisteredButton.css";

const RegisteredButton = (props) => {
    const { className, handLogo } = props;

    return (
        <Link href="/investments">
            <div className="registered-button">
                <div className="overlap-group2-3">
                    <img className="right-36" src={right2} />
                    <div className="group-1000006348">
                        <div className={`registered-12 ${className || "nunito-bold-azure-radiance-14px"}`}>Registered</div>
                    </div>
                    <img className="group" src={`${handLogo || group5}`} />
                </div>
            </div>
        </Link>
    );
};

export default RegisteredButton;